import { Component, ElementRef, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomManufacturerCampaign, ManufacturerCampaignExportData, ManufacturerCampaignExportDataList } from '../../custom-manufacturer-campaign.models';
import { ViewChild } from '@angular/core';
import { CustomManufacturerCampaignService } from '../../custom-manufacturer-campaign.service';
import { tap } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'app-custom-manufacturer-campaign-export',
    templateUrl: './custom-manufacturer-campaign-export.component.html',
    styleUrls: ['./custom-manufacturer-campaign-export.component.scss'],
    standalone: false
})
export class CustomManufacturerCampaignExportComponent implements OnInit {

  @Input() manufacturerCampaigns?: CustomManufacturerCampaign[];
  @Input() b2bUnitId?: string;
  @ViewChildren('productCheckboxes') productCheckboxes: QueryList<ElementRef>;
  selectedCampaigns: string[] = [];

  selectedmanufacturerCampaigns: string[] = [];
  selectedCampaignProducts: string[] = [];
  campaignProductsMap = new Map<string, string[]>();
  campaignProducts: string[] = [];

  public emptyResults$ = new BehaviorSubject(false);
  disableSubmitButton: boolean = true;
  manufacturer: string;

  constructor(
    private manufacturerService: CustomManufacturerCampaignService,
    private datePipe: DatePipe,
    public modal: NgbActiveModal,
  ) { }

  ngOnInit(): void {
    if(this.manufacturerCampaigns.length > 0) {
      this.manufacturer = this.manufacturerCampaigns[0].manufacturer;
    }
    this.fillCampaignProductMap();
  }

  onSubmit() {
    this.productCheckboxes.forEach((element) => {
      if (element.nativeElement.checked) {
        this.selectedCampaignProducts.push(element.nativeElement.id);
      }
    });
    this.submitExportData();
  }

  checkAllColumns() {
    this.productCheckboxes.forEach((element) => {
      element.nativeElement.checked = true;
    });
  }

  uncheckAllColumns() {
    this.productCheckboxes.forEach((element) => {
      element.nativeElement.checked = false;
    });
  }

  fillCampaignProductMap() {
    for(let i = 0; i<this.manufacturerCampaigns.length; i++)
    {
        let campaignKey = this.manufacturerCampaigns[i].id + " - " + this.manufacturerCampaigns[i].name;
        if(this.campaignProductsMap.has(campaignKey)){
          this.campaignProductsMap.get(campaignKey).push(this.manufacturerCampaigns[i].productCode);
        }else {
          let productCode = [this.manufacturerCampaigns[i].productCode];
          this.campaignProductsMap.set(campaignKey, productCode);
        }
    }
  }

  submitExportData() {
    let campaignDataList = {} as ManufacturerCampaignExportDataList;
    campaignDataList.manufacturerCampaignExportList = [];
    this.selectedCampaigns.forEach(campaign => {
      let campaignData = {} as ManufacturerCampaignExportData;
      campaignData.campaignId = campaign.split(" - ")[0];
      campaignData.productCodes = this.selectedCampaignProducts;
      const dataFormat = 'yyyy-MM-dd HH:mm:ss.SSS';
      const UTC = 'UTC';

      campaignDataList.manufacturerCampaignExportList.push(campaignData);
    });



    this.manufacturerService.exportManufacturerCampaigns(campaignDataList).pipe(
      tap(
        (data) => {
          if(data.size > 0) {
            var a = document.createElement('a');
            var timeStamp = this.datePipe.transform(new Date(),'yyyy-MM-dd HH:mm:ss', 'UTC');
            let multipleCampaigns = campaignDataList.manufacturerCampaignExportList && campaignDataList.manufacturerCampaignExportList.length > 1 ;
            let fileMiddleName = multipleCampaigns ?  '_multiple_campaigns_' : campaignDataList.manufacturerCampaignExportList[0].campaignId ;
            let fileName = '['+ this.b2bUnitId + ']' + '['+ this.manufacturer + ']' + '[' + fileMiddleName + ']' + '_[' + timeStamp + ']';
            a.setAttribute('download', fileName + '.csv' );
            a.href = URL.createObjectURL(data);
            a.click();
            this.emptyResults$.next(false);
            this.modal.close();
          } else {
            this.emptyResults$.next(true);
          }
        },
        () => {
        }
      )
    )
    .subscribe(() => { });
  }

  selectCampaign() {
    this.campaignProducts = [];
    this.selectedCampaigns.forEach(campaign => {
      this.campaignProducts.push.apply(this.campaignProducts,this.campaignProductsMap.get(campaign));
    });
    this.campaignProducts = [... new Set(this.campaignProducts)];
    this.disableSubmitButton = false;
  }

}
